const WRITE_PROJECT = 'WRITE_PROJECT';
const WRITE_USER = 'WRITE_USER';
const WRITE_ROLE = 'WRITE_ROLE';
const VIEW_ALL_PROJECT = 'VIEW_ALL_PROJECT';
const VIEW_ACTIVE_PROJECT = 'VIEW_ACTIVE_PROJECT';
const VIEW_PREPARATION_PROJECT = 'VIEW_PREPARATION_PROJECT';
const VIEW_DEACTIVATED_PROJECT = 'VIEW_DEACTIVATED_PROJECT';
const VIEW_VOIDED_PROJECT = 'VIEW_VOIDED_PROJECT';
const VIEW_DELETED_PROJECT = 'VIEW_DELETED_PROJECT';
const WRITE_PASS_ROLE = 'WRITE_PASS_ROLE';
const WRITE_ANY_PASS_ROLE = 'WRITE_ANY_PASS_ROLE';
const WRITE_OVERRIDDEN_SCOPES_BY_ROLE_IN_PROJECT_CATEGORY =
  'WRITE_OVERRIDDEN_SCOPES_BY_ROLE_IN_PROJECT_CATEGORY';
const WRITE_BUDGET_CATEGORY = 'WRITE_BUDGET_CATEGORY';
const WRITE_PROJECT_CATEGORY = 'WRITE_PROJECT_CATEGORY';
const WRITE_APPROVAL_ROUTE_TEMPLATE = 'WRITE_APPROVAL_ROUTE_TEMPLATE';
const WRITE_REPORTING_PERIOD = 'WRITE_REPORTING_PERIOD';
const VIEW_ANNUAL_REPORT = 'VIEW_ANNUAL_REPORT';
const VIEW_ALL_ANNUAL_REPORT = 'VIEW_ALL_ANNUAL_REPORT';
const WRITE_ANNUAL_REPORT = 'WRITE_ANNUAL_REPORT';
const WRITE_ANNUAL_REPORT_WITH_CUSTOM_DATE =
  'WRITE_ANNUAL_REPORT_WITH_CUSTOM_DATE';
const VIEW_ANNUAL_REPORT_PROJECT = 'VIEW_ANNUAL_REPORT_PROJECT';
const WRITE_FACULTY = 'WRITE_FACULTY';
const WRITE_DEPARTMENT = 'WRITE_DEPARTMENT';
const ASSIGN_APPROVER = 'ASSIGN_APPROVER';
const VOID_VIREMENT = 'VOID_VIREMENT';
const VOID_PROPOSAL_REVISION = 'VOID_PROPOSAL_REVISION';
const VOID_EXTENSION = 'VOID_EXTENSION';
const VOID_WITHDRAWAL = 'VOID_WITHDRAWAL';
const WRITE_EMAIL_TEMPLATE = 'WRITE_EMAIL_TEMPLATE';
const VIEW_PROJECT_PROPOSAL = 'VIEW_PROJECT_PROPOSAL';
const VIEW_HISTORY_LOG_BY_PMS = 'VIEW_HISTORY_LOG_BY_PMS';
const WRITE_TEAM = 'WRITE_TEAM';
const VIEW_TEAM = 'VIEW_TEAM';
const WRITE_BUDGET = 'WRITE_BUDGET';
const VIEW_BUDGET = 'VIEW_BUDGET';
const VIEW_VIREMENT = 'VIEW_VIREMENT';
const WRITE_VIREMENT = 'WRITE_VIREMENT';
const WRITE_VIREMENT_WITH_CUSTOM_DATE = 'WRITE_VIREMENT_WITH_CUSTOM_DATE';
const VIEW_PROPOSAL_REVISION = 'VIEW_PROPOSAL_REVISION';
const WRITE_PROPOSAL_REVISION = 'WRITE_PROPOSAL_REVISION';
const WRITE_PROPOSAL_REVISION_WITH_CUSTOM_DATE =
  'WRITE_PROPOSAL_REVISION_WITH_CUSTOM_DATE';
const VIEW_EXTENSION = 'VIEW_EXTENSION';
const WRITE_EXTENSION = 'WRITE_EXTENSION';
const WRITE_EXTENSION_WITH_CUSTOM_DATE = 'WRITE_EXTENSION_WITH_CUSTOM_DATE';
const VIEW_WITHDRAWAL = 'VIEW_WITHDRAWAL';
const WRITE_WITHDRAWAL = 'WRITE_WITHDRAWAL';
const WRITE_WITHDRAWAL_WITH_CUSTOM_DATE = 'WRITE_WITHDRAWAL_WITH_CUSTOM_DATE';
const VIEW_TERMINATION = 'VIEW_TERMINATION';
const WRITE_TERMINATION = 'WRITE_TERMINATION';
const WRITE_TERMINATION_WITH_CUSTOM_DATE = 'WRITE_TERMINATION_WITH_CUSTOM_DATE';
const VIEW_REPORT_SUBMISSION = 'VIEW_REPORT_SUBMISSION';
const WRITE_SCHEDULED_REPORT_SUBMISSION = 'WRITE_SCHEDULED_REPORT_SUBMISSION';
const SUBMIT_REPORT = 'SUBMIT_REPORT';
const SUBMIT_REPORT_WITH_CUSTOM_DATE = 'SUBMIT_REPORT_WITH_CUSTOM_DATE';
const VIEW_OTHER_REPORTS = 'VIEW_OTHER_REPORTS';
const WRITE_PROJECT_APPLICATION_SETTING = 'WRITE_PROJECT_APPLICATION_SETTING';
const WRITE_PROJECT_APPLICATION = 'WRITE_PROJECT_APPLICATION';
const VIEW_PROJECT_APPLICATION = 'VIEW_PROJECT_APPLICATION';
const ASSIGN_PROJECT_APPLICATION_ENDORSER =
  'ASSIGN_PROJECT_APPLICATION_ENDORSER';

export const SCOPE_TYPES = {
  WRITE_USER,
  WRITE_PROJECT,
  WRITE_ROLE,
  VIEW_ALL_PROJECT,
  VIEW_ACTIVE_PROJECT,
  WRITE_PASS_ROLE,
  WRITE_ANY_PASS_ROLE,
  WRITE_OVERRIDDEN_SCOPES_BY_ROLE_IN_PROJECT_CATEGORY,
  WRITE_BUDGET_CATEGORY,
  WRITE_PROJECT_CATEGORY,
  WRITE_APPROVAL_ROUTE_TEMPLATE,
  WRITE_REPORTING_PERIOD,
  VIEW_ANNUAL_REPORT,
  VIEW_ALL_ANNUAL_REPORT,
  WRITE_ANNUAL_REPORT,
  WRITE_ANNUAL_REPORT_WITH_CUSTOM_DATE,
  VIEW_ANNUAL_REPORT_PROJECT,
  WRITE_FACULTY,
  WRITE_DEPARTMENT,
  VIEW_VIREMENT,
  VIEW_EXTENSION,
  VIEW_WITHDRAWAL,
  VIEW_TERMINATION,
  ASSIGN_APPROVER,
  VOID_VIREMENT,
  VOID_PROPOSAL_REVISION,
  VOID_EXTENSION,
  VOID_WITHDRAWAL,
  WRITE_EMAIL_TEMPLATE,
  VIEW_PROJECT_PROPOSAL,
  VIEW_HISTORY_LOG_BY_PMS,
  WRITE_TEAM,
  VIEW_TEAM,
  WRITE_BUDGET,
  VIEW_BUDGET,
  WRITE_VIREMENT,
  WRITE_VIREMENT_WITH_CUSTOM_DATE,
  VIEW_PROPOSAL_REVISION,
  WRITE_PROPOSAL_REVISION,
  WRITE_PROPOSAL_REVISION_WITH_CUSTOM_DATE,
  WRITE_EXTENSION,
  WRITE_EXTENSION_WITH_CUSTOM_DATE,
  WRITE_WITHDRAWAL,
  WRITE_WITHDRAWAL_WITH_CUSTOM_DATE,
  WRITE_TERMINATION,
  WRITE_TERMINATION_WITH_CUSTOM_DATE,
  VIEW_REPORT_SUBMISSION,
  WRITE_SCHEDULED_REPORT_SUBMISSION,
  SUBMIT_REPORT,
  SUBMIT_REPORT_WITH_CUSTOM_DATE,
  VIEW_PREPARATION_PROJECT,
  VIEW_DEACTIVATED_PROJECT,
  VIEW_VOIDED_PROJECT,
  VIEW_DELETED_PROJECT,
  VIEW_OTHER_REPORTS,
  WRITE_PROJECT_APPLICATION_SETTING,
  WRITE_PROJECT_APPLICATION,
  VIEW_PROJECT_APPLICATION,
  ASSIGN_PROJECT_APPLICATION_ENDORSER,
};
